import axios from 'axios';
import nextTick from 'next-tick';
import { AppConfig } from '../AppConfig';
import { AuthenticationService } from '../AuthenticationService';
import { BaseService } from '../BaseService';
import { createSingleton } from '../singleton';
import { createDiagnosticLogger } from '../createDiagnosticLogger';
const diagnosticLogger = createDiagnosticLogger('bi:core:services:CanIService');
/* 
            
           
                                                                                       
 */
class CanIService extends BaseService {
    static MODEL;
    _isCompatibleMode = false;
    _pending = {};
    _pendingPromise = null;
    _pendingResolve;
    _queued = {};
    _queuedPromise = null;
    _queueResolve;
    _currentRequest = null;
    constructor() {
        super({ loading: false, error: null });
    }
    /* 
              
                                                                            
                                                            
     */
    one(claim) {
        return this.ensure([claim])
            .then(model => model[claim])
            .catch(() => false);
    }
    /* 
              
                                                                                                        
                                                                                       
     */
    ensure(claims) {
        const queueds = claims.filter(claim => this._queued[claim]);
        const pendings = claims.filter(claim => this._pending[claim]);
        claims = claims.filter(claim => this._model[claim] === undefined && !this._pending[claim] && !this._queued[claim]);
        if (!claims.length) { //                          
            if (queueds.length) { //                                    
                return this._queuedPromise;
            }
            else if (pendings.length) { //                                    
                return this._pendingPromise;
            }
            else { //           
                return Promise.resolve(this._model);
            }
        }
        //                        
        claims.forEach(claim => this._queued[claim] = true); //                    
        if (!this._queuedPromise) { //                                        
            this._queuedPromise = new Promise(resolve => { this._queueResolve = resolve; }); //                             
        }
        if (!this._currentRequest) { //                   
            this._currentRequest = new Promise(resolve => resolve()).then(() => this._run()); //                           
        }
        return this._queuedPromise;
    }
    //                                                     
    async _run() {
        console.assert(Object.keys(this._queued).length !== 0); //                 
        console.assert(Object.keys(this._pending).length === 0); //                            
        console.assert(this._pendingPromise === null);
        const claims = Object.keys(this._queued);
        this._queued = {}; //                
        claims.forEach(claim => this._pending[claim] = true); //                                    
        this._pendingPromise = this._queuedPromise; //                                
        this._pendingResolve = this._queueResolve;
        this._queuedPromise = null;
        this._queueResolve = null;
        let newLoadedItems;
        try {
            if (this._isCompatibleMode) {
                newLoadedItems = await this._loadCompatible(claims);
            }
            else {
                newLoadedItems = await this._load(claims);
            }
        }
        catch (err) {
            diagnosticLogger.error(err);
            //                                                          
            newLoadedItems = {};
            claims.forEach(claim => newLoadedItems[claim] = false);
        }
        const resolve = this._pendingResolve; //                                                                                      
        this._pending = {}; //                        
        this._pendingPromise = null; //                                 
        this._pendingResolve = null; //                                                                        
        this._updateModel(newLoadedItems);
        resolve(this._model);
        if (Object.keys(this._queued).length) { //                                                                                         
            this._currentRequest = new Promise(resolve => resolve()).then(() => this._run());
        }
        else {
            this._currentRequest = null;
        }
        return this._model;
    }
    /* 
              
                                                                              
                                                                                                                         
                                                                                  
                                                                                                       
                                                
     */
    _load(claims) {
        //                                           
        return axios({
            url: AppConfig.fixRequestUrl('/api/can/i'),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            data: claims,
            //                           
        }).then((response) => {
            return response.data;
        }).catch(err => {
            if (err.isAxiosError && err.response?.status === 404) {
                this._isCompatibleMode = true;
                return this._loadCompatible(claims);
            }
            else { //                                         
                throw err;
            }
        });
    }
    /* 
              
                                                                              
                                                                                                                         
                                                                                           
                                                              
                                                                                 
                                                                                  
                                                                                                                       
                                                                                                    
     */
    _loadCompatible(claims) {
        return new Promise(resolve => {
            const partial = {};
            const isAdmin = AuthenticationService.getModel().access_level === 'admin';
            claims.forEach(claim => {
                if (claim === 'L koob.cubes')
                    partial[claim] = true; //                                     
                else if (claim === 'L koob.dimensions')
                    partial[claim] = true; //             
                else if (claim.match(/^\w+ rbac/))
                    partial[claim] = false; //                     
                else if (claim.match(/^\w+ ds_\w+\.data_sources/))
                    partial[claim] = false; //                                    
                else if (claim.match(/^\w+ ds_\w+\.cubes/))
                    partial[claim] = false; //                            
                else if (claim.match(/^\w+ bm\.topics\/\d+/))
                    partial[claim] = true; //                
                else if (claim.match(/^\w+ ds_\w+\.dashlets/))
                    partial[claim] = true; //                       
                else if (claim.match(/^\w+ ds_\w+\.dashboards/))
                    partial[claim] = true; //                        
                else if (claim === 'Config? authorization.mode')
                    partial[claim] = 'rbac'; //                 
                else if (claim === 'Config? authorization.themeEditor.siteRole.allowed')
                    partial[claim] = null;
                else if (claim.startsWith('Config?'))
                    partial[claim] = null; //                            
                else if (claim === 'UserInfo? my.site_role/Viewer')
                    partial[claim] = !isAdmin; //                         
                else if (claim.match(/C adm\.datasets\/ds_.*/))
                    partial[claim] = true; //                
                else if (claim.match(/R adm\.datasets\/ds_.*/))
                    partial[claim] = true; //             
                else if (claim.match(/U adm\.datasets\/ds_.*/))
                    partial[claim] = true; //               
                else if (claim.match(/D adm\.datasets\/ds_.*/))
                    partial[claim] = true; //              
                else if (claim.match(/O adm\.datasets\/ds_.*/))
                    partial[claim] = true; //                
                else if (claim === 'C adm.topics')
                    partial[claim] = true; //                
                else if (claim === 'R adm.topics')
                    partial[claim] = true; //             
                else if (claim === 'U adm.topics')
                    partial[claim] = true; //               
                else if (claim === 'D adm.topics')
                    partial[claim] = true; //              
                else
                    partial[claim] = isAdmin;
            });
            nextTick(() => {
                resolve(partial);
            });
        });
    }
    /* 
              
                                                                                                            
                        
     */
    can = (claim) => {
        return this.getModel()[claim];
    };
    /* 
              
                                                                                                            
                        
     */
    static can = (claim) => {
        return CanIService.getInstance().can(claim);
    };
    /* 
              
                                                                            
                                                            
     */
    static one(claim) {
        return this.getInstance().one(claim);
    }
    /* 
              
                                                                                                        
                                                                                       
     */
    static ensure(claims) {
        return this.getInstance().ensure(claims);
    }
    static getModel() {
        return this.getInstance().getModel();
    }
    static subscribeUpdatesAndNotify(listener) {
        return this.getInstance().subscribeUpdatesAndNotify(listener);
    }
    static unsubscribe(listener) {
        return this.getInstance().unsubscribe(listener);
    }
    /* 
                    
                                                                                          
                                                                                                     
     */
    helpFindClaim(pattern) {
        const model = this.getModel();
        const allEntries = Object.entries(model).filter(([key]) => key !== 'loading' && key !== 'error');
        const matched = allEntries.filter(([key]) => key.includes(pattern));
        const logEntry = (key, value) => {
            const color = value === false ? 'color: red' : 'color: green';
            diagnosticLogger.log(`%c  ${key}: ${value}`, color);
        };
        diagnosticLogger.log(`%c[CanIService] pattern="${pattern}", total: ${allEntries.length}, matched: ${matched.length}`, 'color: orange; font-weight: bold');
        matched.forEach(([key, value]) => logEntry(key, value));
    }
    static getInstance = createSingleton(() => new CanIService(), '__canIService');
}
export default CanIService;
